module.exports = __webpack_public_path__ + "d9cf517802956cd88eadcb9158aa6dec.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-HairlineItalic.woff2
// module id = 958
// module chunks = 0